import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { LOGINPAGE } from "../../constants";
import { loginApiPayload } from "../../redux/actions/loginAction";

export default function Index() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loginApiPayload(null));
  }, []);

  return (
    <div>
      <h5>User Successfully Logged Out.</h5>
      <div>
        <a id="login" href={LOGINPAGE}>
          Click here to Login.
        </a>
      </div>
    </div>
  );
}
